import { IDayCell } from './calendar'
import { IPhoneEvent, sortEvents } from './phone-events'
import events from './events'
import phoneCalendar from './phone-calendar'

// The one list of events a day has: Emrouz's own and the phone's, merged and
// put in reading order together.
//
// The two sources stay apart everywhere else — one is a store this app owns,
// the other is a live read of the phone — but a day does not care where an
// appointment came from, so this is where they stop being two things. On the
// web the phone side is simply empty, and Emrouz's own events are the whole
// list.

export function forDay(cell: IDayCell): IPhoneEvent[] {
    return sortEvents([...events.forDay(cell), ...phoneCalendar.forDay(cell)])
}

export default { forDay }
